import service from '../../services/commonUser.service'
import { getToken, setToken, removeToken } from '../auth'

const user = {
  state: {
    usuario: {},
    token: getToken(),
    prontuario: {}
  },

  mutations: {
    SET_PRONTUARIO: (state, prontuario) => {
      state.prontuario = prontuario
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.usuario = user
    },
    SET_VOLUME: (state, volume) => {
      state.usuario.volume = volume // me
    },
    SET_INFOPACIENTE: (state, infoPaciente) => {
      state.usuario.infoPaciente = infoPaciente
    },
    SET_VIDEO_ID: (state, videoId) => {
      state.usuario.videoId = videoId // me
    },
    SET_RELOADS: (state, valor) => {
      state.usuario.reloads = valor // me
    },
    SET_USERNAME: (state, nome) => { // feito por mim
      state.usuario.nome = nome
    },
    SET_GUICHE: (state, guiche) => { // feito por mim
      state.usuario.guiche = guiche
    },
    SET_SERVICOS_RECEPCIONISTA: (state, servicosRecepcionista) => { // feito por mim
      state.usuario.servicosRecepcionista = servicosRecepcionista
    },
    SET_TEXTO_SELECIONAR_TODOS: (state, textoSelecionarTodos) => {
      state.usuario.textoSelecionarTodos = textoSelecionarTodos
    },
    SET_QUANTATENDIMENTOS: (state, valor) => { // feito por mim
      state.usuario.quantAtendimentos = valor
    },
    SET_LOCAL: (state, local) => { // feito por mim
      state.usuario.nomeLocal = local
    },

    SET_DADOS_MEDICO: (state, nomeConsultorioServicos) => { // feito por mim
      state.usuario.nomeConsultorioServicos = nomeConsultorioServicos
    },

    LOCAL_ESCOLHIDO: (state, localEscolhido) => { // feito por mim
      state.usuario.localEscolhido = localEscolhido
    },
    SERVICOS_DISPONIBILIDADE: (state, ServicosDisponibilidade) => { // feito por mim
      state.usuario.ServicosDisponibilidade = ServicosDisponibilidade
    },
    SERVICOS_ESCOLHIDOS: (state, servicosEscolhidos) => { // feito por mim
      state.usuario.servicosEscolhidos = servicosEscolhidos
    },

    SET__PAINEL: (state, login) => {
      state.usuario.loginPainel = login
    },
    SET_SENHA_PAINEL: (state, senha) => {
      state.usuario.senhaPainel = senha
    },
    SET_PRIMEIROACESSO_PAINEL: (state, bool) => {
      state.usuario.primeiroAcesso = bool
    }
  },

  actions: {
    // Login por nome do usuário
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        service.usuario.login(userInfo)
          .then(resp => {
            if (resp.status === 200) {
              console.log('login>>>', resp.data)
              commit('SET_USER', resp.data.result)
              setToken(resp.data.token)
              resolve(resp.data.result)
            } else {
              // Rejeita com a mensagem de erro do servidor, se disponível
              reject(resp.data.message || 'Login ou senha inválidos')
            }
          })
          .catch(error => {
            // Captura e formata melhor a mensagem de erro
            let errorMessage = 'Erro ao tentar fazer login'

            if (error.response) {
              // O servidor respondeu com um status fora do range 2xx
              errorMessage = error.response.data.message ||
                        error.response.data.error ||
                        `Erro ${error.response.status}: ${error.response.statusText}`
            } else if (error.request) {
              // A requisição foi feita mas não houve resposta
              errorMessage = 'Sem resposta do servidor - verifique sua conexão'
            }

            reject(errorMessage)
          })
      })
    },

    // Front end
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER', '') // modificada
        // commit('SET_GUICHE_ATENDENTE', '') // modificada
        removeToken()
        resolve()
        setRoles([])
      })
    },

    updateProntuario ({ commit }, prontuario) {
      return new Promise(resolve => {
        commit('SET_PRONTUARIO', prontuario)
      })
    },

    UpdateUser ({ commit }, user) {
      return new Promise(resolve => {
        commit('SET_USER', user) // EU ADICIONEI ISTO
      })
    },

    UpdateVolume ({ commit }, volume) {
      return new Promise(resolve => {
        commit('SET_VOLUME', volume) // EU ADICIONEI ISTO
      })
    },

    VideoId ({ commit }, videoId) {
      return new Promise(resolve => {
        commit('SET_VIDEO_ID', videoId) // EU ADICIONEI ISTO
      })
    },
    Reloads ({ commit }, valor) {
      return new Promise(resolve => {
        commit('SET_RELOADS', valor) // EU ADICIONEI ISTO
      })
    },

    ServicosRecepcionista ({ commit }, servicosRecepcionista) {
      return new Promise(resolve => {
        commit('SET_SERVICOS_RECEPCIONISTA', servicosRecepcionista) // EU ADICIONEI ISTO
      })
    },
    TextoSelecionarTodos ({ commit }, textoSelecionarTodos) {
      return new Promise(resolve => {
        commit('SET_TEXTO_SELECIONAR_TODOS', textoSelecionarTodos) // EU ADICIONEI ISTO
      })
    },
    Guiche ({ commit }, guiche) {
      return new Promise(resolve => {
        commit('SET_GUICHE', guiche) // EU ADICIONEI ISTO
      })
    },
    QuantAtendimentos ({ commit }, valor) {
      return new Promise(resolve => {
        commit('SET_QUANTATENDIMENTOS', valor) // EU ADICIONEI ISTO
      })
    },
    Local ({ commit }, local) {
      return new Promise(resolve => {
        commit('SET_LOCAL', local) // EU ADICIONEI ISTO
      })
    },
    NomeConsultorioServicos ({ commit }, NomeConsultorioServicos) {
      return new Promise(resolve => {
        commit('SET_DADOS_MEDICO', NomeConsultorioServicos) // EU ADICIONEI ISTO
      })
    },
    ServicosDisponibilidade ({ commit }, ServicosDisponibilidade) {
      return new Promise(resolve => {
        commit('SERVICOS_DISPONIBILIDADE', ServicosDisponibilidade) // EU ADICIONEI ISTO
      })
    },
    LocalEscolhido ({ commit }, LocalEscolhido) {
      return new Promise(resolve => {
        commit('LOCAL_ESCOLHIDO', LocalEscolhido) // EU ADICIONEI ISTO
      })
    },

    ServicosEscolhidos ({ commit }, ServicosEscolhidos) {
      return new Promise(resolve => {
        commit('SERVICOS_ESCOLHIDOS', ServicosEscolhidos) // EU ADICIONEI ISTO
      })
    },

    SetUserName ({ commit }, nome) {
      return new Promise(resolve => {
        commit('SET_USERNAME', nome) // EU ADICIONEI ISTO
      })
    },
    SetToken ({ commit }, token) {
      return new Promise(resolve => {
        commit('SET_TOKEN', token) // EU ADICIONEI ISTO
      })
    },
    SetSenhaPainel ({ commit }, senha) {
      return new Promise(resolve => {
        commit('SET_SENHA_PAINEL', senha) // EU ADICIONEI ISTO
      })
    },
    SetLoginPainel ({ commit }, login) {
      return new Promise(resolve => {
        commit('SET_LOGIN_PAINEL', login) // EU ADICIONEI ISTO
      })
    },
    SetPrimeiroAcessoPainel ({ commit }, bool) {
      return new Promise(resolve => {
        commit('SET_PRIMEIROACESSO_PAINEL', bool) // EU ADICIONEI ISTO
      })
    },
    SetInfoPaciente ({ commit }, info) {
      commit('SET_INFOPACIENTE', info)
    }
  }
}

export default user
